import api from './api';

const ruleQ = (ruleId) => (ruleId ? `?ruleId=${ruleId}` : '');

const paymentMethodService = {
    list:    (ppId, ruleId)          => api.get(`/paymentporter/${ppId}/payment-methods${ruleQ(ruleId)}`),
    getById: (ppId, methodId)        => api.get(`/paymentporter/${ppId}/payment-methods/${methodId}`),
    create:  (ppId, data, ruleId)    => api.post(`/paymentporter/${ppId}/payment-methods${ruleQ(ruleId)}`, data),
    update:  (ppId, methodId, data)  => api.put(`/paymentporter/${ppId}/payment-methods/${methodId}`, data),
    remove:  (ppId, methodId)        => api.delete(`/paymentporter/${ppId}/payment-methods/${methodId}`),
};

export default paymentMethodService;
